import script from "./address.vue?vue&type=script&setup=true&lang=ts"
export * from "./address.vue?vue&type=script&setup=true&lang=ts"

import "./address.vue?vue&type=style&index=0&id=e1f97fa6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1f97fa6"]])

export default __exports__